var render = function(_h, _vm) {
  var _c = _vm._c
  return _vm._m(0)
}
var staticRenderFns = [
  function(_h, _vm) {
    var _c = _vm._c
    return _c("span", { staticClass: "fa-stack fa-lg" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-1x stack-background" }),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-magic fa-stack-1x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }